import React from 'react';
import { PropTypes } from 'prop-types';
// styles
import styled, { css } from 'styled-components';
import { media } from 'utils/style';

const RelativeDiv = styled.div`
  position: relative;
  z-index: 10;
`;
const RowOptionsContainer = ({ className, children }) => {
  return (
    <RelativeDiv>
      <div role="menu" className={className}>
        {children}
      </div>
    </RelativeDiv>
  );
};

RowOptionsContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  isVisible: PropTypes.bool,
};

const regularCSS = css`
  background-color: var(--white);
  border-radius: 4px;
  border: solid 1px var(--grey-mouse);
  box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  padding: 4px 0px;
  gap: 2px;
  display: ${(props) => (props.isVisible ? 'initial' : 'none')};
  position: absolute;
  right: 0px;
  top: calc(100% + 1px);
  left: auto;
`;

const mobileCSS = css`
  height: 100%;
  border-radius: 0px;
  border: none;
  box-shadow: none;
  left: 0;
  height: 100vh;
  right: 0;
  background: rgba(38, 51, 64, 0.8);
  padding-top: 0px;
  top: 72px;
`;

const StyledRowOptionsContainer = styled(RowOptionsContainer)`
  ${regularCSS}
  ${media.lessThan('small')`${mobileCSS}`}
`;

export default StyledRowOptionsContainer;
